module.exports = __webpack_public_path__ + "img/communication.e8b02a01.png";